export default __webpack_public_path__ + "static/media/hv-tray.6c80be5b.png";